
import moment from 'moment'
import { mapGetters } from 'vuex' // Keep for detectedTimezone
import promoData from '@/data/promo.json'

export default {
  data: () => ({
    time: {Days:"0",Hours:"0",Minutes:"0",Seconds:"0"},
    zeroTime: {Days:"00",Hours:"00",Minutes:"00",Seconds:"00"},
    i: 0,
    ended: false,
    countdown: null // Will store the moment object for the webinar datetime
  }),

  computed: {
    ...mapGetters({
      detectedTimezone: 'geolocation/detectedTimezone',
      // userRegion: 'geolocation/region' // Not needed if not using region-specific promo data
    }),
    bgColour() {
      return '#F76386';
    }
  },

  mounted() {
    // Directly use promoData.webinarDatetime
    if (promoData.webinarDatetime) {
      const targetDate = moment(promoData.webinarDatetime).tz('Europe/London');
      // Check for DST
      // if (targetDate.isDST()) {
      //   targetDate = targetDate.subtract(1, 'hours');
      // }
      const todayDate = moment().tz(this.detectedTimezone || 'Europe/London');

      if (todayDate.isAfter(targetDate)) {
        this.ended = true;
      } else {
        this.countdown = targetDate; // Directly set the countdown target
        this.update();
      }
    } else {
      console.warn('promoData.webinarDatetime not found. Countdown will not start.');
      this.ended = true; // If no webinar date, just show zeros
    }
  },
  // Added beforeDestroy to clean up the requestAnimationFrame
  beforeDestroy() {
    if (this.frame) {
      window.cancelAnimationFrame(this.frame);
    }
  },

  methods: {
    update() { 
      // Clear any existing animation frame to prevent multiple updates
      if (this.frame) {
        window.cancelAnimationFrame(this.frame);
      }
      
      this.frame = window.requestAnimationFrame(this.update.bind(this));
      
      // Update every 10 frames (approx. 100ms at 60fps) for performance
      if (this.i++ % 10) { return; }

      const currentTime = moment().tz(this.detectedTimezone || 'Europe/London');

      if (this.countdown) { 
        const diff = this.countdown.diff(currentTime);

        if (diff <= 0) {
          this.ended = true;
          window.cancelAnimationFrame(this.frame); // Stop updating once ended
          this.time = { Days: "00", Hours: "00", Minutes: "00", Seconds: "00" };
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / 1000 / 60) % 60);
        const seconds = Math.floor((diff / 1000) % 60);
        
        this.time = {
          Days: days.toString(),
          Hours: hours.toString(),
          Minutes: minutes.toString(),
          Seconds: seconds.toString()
        };
      } else {
        // Fallback or initial state if countdown is not set
        this.time = { Days: "00", Hours: "00", Minutes: "00", Seconds: "00" };
      }
    }
  }
}
